import angular from "angular";
import { SubFilter } from "./subFilters";

export class StringFilter
  extends SubFilter {

  getGui(): angular.IAugmentedJQuery {
    return angular.element(`<input ng-model="${this.getQueryFieldExpression()}" ng-model-options="gridFilterController.defaultModelOptions" class="form-control" />`);
  }
}

